import Plyr from "plyr";

(function () {
  'use strict';

  var $ = window.jQuery;

  function VideoPopup(options) {
    if (true === window.isPartial) {
      return;
    }

    if (!options) {
      throw new Error('No options passed to VideoPopup constructor');
    }
    this.options = $.extend({}, VideoPopup.defaults, options);
    this.setup();
  }

  VideoPopup.prototype.setup = function () {
    var $self = this;

    $(document).on('click', '[data-init="' + this.options.initDataSelector + '"]', function (e) {
      e.preventDefault();
      var $element = $(this),
        $postUrl = $(this).data('url');

      if (!$postUrl) {
        console.error('Post URL does not set for the popup');
        return;
      }

      $.fancybox.open({
        src: $postUrl,
        opts: {
          slideClass: $self.options.slideClass,
          baseClass: $self.options.baseClass,
          baseTpl: $self.options.baseTpl,
          afterClose: function () {
            $element.focus();
          },
          afterShow(instance, current) {
            const wrapper = document.querySelector('.fancybox-content')
            const video = wrapper.querySelector('video')
            new Plyr(video || wrapper)
            $('.fancybox-slide').css({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            })
          },
        }
      });

      return false;
    });
  };

  VideoPopup.defaults = {
    initDataSelector: 'videoPopup',
    idSelector: 'id',
    slideClass: 'video_popup__slide',
    baseClass: 'video_popup__container',
    baseTpl:
      '<div class="fancybox-container video_popup__container" role="dialog" tabindex="-1">' +
      '<div class="fancybox-bg"></div>' +
      '<div class="fancybox-inner">' +
      '<div class="fancybox-infobar">' +
      "<span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span>" +
      "</div>" +
      '<div class="fancybox-toolbar">{{buttons}}</div>' +
      '<div class="fancybox-navigation">{{arrows}}</div>' +
      '<div class="fancybox-stage"></div>' +
      '<div class="fancybox-caption"></div>' +
      "</div>" +
      "</div>"
  };

  window.VideoPopup = VideoPopup;
}());
